import { Component, ComponentFactoryResolver, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NicaMaster } from '../../../components/nica-master-component/nica-master.component';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Apiservice } from '../../../services/api.service';
import { ComponentService } from '../../../services/component.service';
import { AnaColumn, FormsTemplateService } from '../../../services/forms-template.service';
import { OverlaySideFormService } from '../../../components/shared/overlay-side-form/overlay-side-form.service';
import { NicaMenuService } from '../../../services/nica-menu.service';
import { RentriService } from '../../../services/rentri.service';
import { AnagraficaService } from '../../../services/anagrafica.service';
import { HttpClient } from '@angular/common/http';
import { NicaDataGridComponent } from '../../../components/nica-data-grid/nica-data-grid.component';
import { alert } from 'devextreme/ui/dialog';

@Component({
  selector: 'app-gestione-altri-soggetti',
  templateUrl: './gestione-altri-soggetti.component.html',
  styleUrls: ['./gestione-altri-soggetti.component.css']
})
export class GestioneAltriSoggettiComponent extends NicaMaster implements OnInit {
  @ViewChild('dataGrid', { static: false }) nicaDataGrid: NicaDataGridComponent
  @Input() itemData: any;

  @Input() SubjectCall: string;
  @Input() returnDatafield: string;
  @Input() data: any = {}
  @Input() tastiBottom = [15,16]
  @Output() outputEmit: EventEmitter<any> = new EventEmitter<any>(); //Emit all'esterno
  @Output() emittendSelectionRow: EventEmitter<any> = new EventEmitter<any>(); //Emit all'esterno


  CustomButtonForm;
  rowindex;
  currentDatafield;
  dynamicGrid;
  currentCampo;
  tableWidth: number = 800
  showDynamicSoggetti: boolean = false;
  returnDataField: any;
  hideForm: boolean = true;
  showGrid: boolean = true;
  colonneGrigliaSoggetti: AnaColumn[] = []
  dataSourceSoggetti = [];
  copyArray: any
  constructor(
    private activateRoute: ActivatedRoute,
    public loader: NgxSpinnerService,

    public apiservice: Apiservice,


    public userComponentService: ComponentService,
    public templateService: FormsTemplateService,
    public _overlaySideFormService: OverlaySideFormService,
    public _overlaySidePanelService: OverlaySideFormService,
    public formTemplateService: FormsTemplateService,
    public _componentFactoryResolver: ComponentFactoryResolver,
    public activatedroute: ActivatedRoute,
    public router: Router,
    public menuService: NicaMenuService,
    public rentriService: RentriService,
    public anagraficaService: AnagraficaService,
    public http: HttpClient,


  ) {
    super(
      userComponentService,
      templateService,
      _overlaySideFormService,
      _overlaySidePanelService,
      formTemplateService,
      _componentFactoryResolver,
      activatedroute,
      router,
      menuService,
      rentriService,
      anagraficaService,

    );
  }



  ngOnInit() {

    /* if (this.itemData) {
      this.setGlobalVariableFromParams(this.itemData)
      this.titleDynamic = this.itemData
      let formData = this.itemData[0].data
      this.rowData['idSede'] = formData.idLotto_Sede;
      this.rowData['idPosizioneRifiuto'] = formData.idPosizioneRifiuto;

      console.log('itemData-->', this.rowData)

    } else {
      this.activatedroute.queryParams
        .subscribe(params => {

          this.currentTabId = params.currentTabId,
            this.currentTabName = params.currentTabName

          this.setGlobalVariableFromParams(params);
          // this.loader.hide()

        });
    } */
    this.copyArray = JSON.parse(JSON.stringify(this.data));
    this.setViewSoggetti()
  }
  setViewSoggetti() {

    this.colonneGrigliaSoggetti = [];

    let formData = this.copyArray
    this.rowData['idSede'] = formData.idLotto_Sede;
    this.rowData['idPosizioneRifiuto'] = formData.idPosizioneRifiuto;

    this.colonneGrigliaSoggetti = JSON.parse(JSON.stringify(this.formTemplateService.getService(this.SubjectCall)));
    //this.colonneGrigliaSoggetti = Object.assign({}, this.formTemplateService.getService(this.SubjectCall));

    for (let colonnaGruppo of this.colonneGrigliaSoggetti) {
      for (let colonna of colonnaGruppo.data) {
        colonna.colVisible = this.setColsView(colonna.dataField);
        if (colonna.dataField == 'descrizione' && this.returnDatafield == 'listaAltriSoggettiT') {
          let queryString = colonna.dynamic.queryString;
          queryString = queryString.concat('&TipoAttivita=T');
          colonna.dynamic.queryString = queryString
        }

        if (colonna.dataField == 'descrizione' && this.returnDatafield == 'listaAltriSoggettiI') {
          let queryString = colonna.dynamic.queryString;
          queryString = queryString.concat('&TipoAttivita=I');
          colonna.dynamic.queryString = queryString;
          colonna.dynamic.detailOption.queryString = '/$idSoggetto?$filter=(isintermediario eq true)'

        }
      }
    }


    switch (this.returnDatafield) {
      case 'listaAltriSoggettiT':

        if (formData.listaAltriSoggettiT) {
          this.dataSourceSoggetti = formData.listaAltriSoggettiT;

        }
        this.tableWidth = 1200;

        break;

      case 'listaAltriSoggettiI':
        if (formData.listaAltriSoggettiI) {
          this.dataSourceSoggetti = formData.listaAltriSoggettiI;

        }
        this.tableWidth = 820;

        break;

      case 'listaInterventiSpurghi':
        if (formData.listaInterventiSpurghi) {
          this.dataSourceSoggetti = formData.listaInterventiSpurghi;

        }
        this.tableWidth = 820;

        break;

      default:
        break;


    }

    this.showGrid = true

  }

  gridEventSoggetti(event) {

    console.log('formEventSoggetti', event);

    if (event.name == 'formContentInitializzed' && (this.returnDataField != 'listaAltriSoggettiI' || this.returnDataField != 'listaAltriSoggettiO')) {

      this.hideForm = false;

    }

    if (event.name == 'onEditingStart') {


      this.manipulateFormGrid(event, event.data);

    }


    if (event == 'saveSoggetto') {

      const formData = this.formSoggetto.formEdit.formData;

      const listaSoggetti = formData.listaSoggetti;


      let dataOuptput = {
        [this.SubjectCall]: listaSoggetti,

        event: 'saveSoggetto'
      }

      this.outputEmit.emit(dataOuptput)
    }

    if (event == 'return') {
      let dataOuptput = {
        name: 'return'
      }

      this.outputEmit.emit(dataOuptput)
    }
  }

  setColsView(dataField) {


    if (this.returnDatafield == 'listaAltriSoggettiT') {
      switch (dataField) {

        case 'numeroNave':
          return true
          break;
        case 'numeroTreno':
          return true
          break;
        case 'operatore':
          return false
          break;
        case 'quantitàKg':
          return false
          break;
        case 'targaAutomezzo':
          return true
          break;
        case 'targaRimorchio':
          return true
          break;
        case 'tipoTrasporto':
          return true
          break;
        case 'descrizione_2':
          return false
          break;
        case 'descrizione':
          return true
          break;
        case 'autorizzazioneAlbo':
          return true
          break;
        default:
          return false

      }
    }


    if (this.returnDatafield == 'listaAltriSoggettiI') {
      switch (dataField) {
        case 'numeroNave':
          return false
          break;
        case 'numeroTreno':
          return false
          break;
        case 'quantitàKg':
          return false
          break;
        case 'targaAutomezzo':
          return false
          break;
        case 'targaRimorchio':
          return false
          break;
        case 'tipoTrasporto':
          return false
          break;
        case 'descrizione_2':
          return false
          break;
        case 'descrizione':
          return true
        case 'operatore':
          return false
          break;
        default:
          return true

      }
    }



    if (this.returnDatafield == 'listaAltriSoggettiO') {

      switch (dataField) {
        case 'numeroNave':
          return false
        case 'numeroTreno':
          return false
        case 'operatore':
          return true
        case 'descrizione_2':
          return false
        case 'descrizione':
          return true
        case 'targaAutomezzo':
          return false
        case 'targaRimorchio':
          return false
        case 'tipoTrasporto':
          return false
        case 'quantita':
          return false
        default:
          return true

      }


    }

  }

  manipulateFormGrid(event, dataValue) {
    const value = dataValue.tipoTrasporto;
    const dataField = event.column.dataField

    switch (value) {
      case "1":
        if (dataField == 'numeroNave' || dataField == 'numeroTreno') {
          event.cancel = true
        }

        break;
      case "2":
        if (dataField == 'numeroNave' || dataField == 'numeroTreno' || dataField == 'targaAutomezzo' || dataField == 'targaRimorchio') {
          event.cancel = true
        }

        break;
      case "3":
        if (dataField == 'numeroNave' || dataField == 'targaAutomezzo' || dataField == 'targaRimorchio') {
          event.cancel = true
        }

        break;
      case "4":
        if (dataField == 'targaAutomezzo' || dataField == 'targaRimorchio') {
          event.cancel = true
        }

        break;
      default:

        event.cancel = false
        break;
    }



  }

  rispostaBottoni(ev) {

    switch (ev) {
      case 16:
      case 23:
        this.data = JSON.parse(JSON.stringify(this.copyArray));
        let datatoSendOutput = {
          name: 'return'
        }
        this.outputEmit.emit(datatoSendOutput)
        break;
      case 15:
      case 22:
        let checkValidation = true
        const editorData = this.nicaDataGrid.editorData

        editorData.forEach(editorDataR => {
          if (editorDataR.edit) {
            alert('Stai ancora modificando la lista', 'Attenzione');

            checkValidation = false
            //return 
          }
        })
        if (!checkValidation) {
          return
        }

        const listaSoggetti = this.dataSourceSoggetti;


        let dataOuptput = {
          retunDatafield: this.returnDatafield,
          listaAltriSoggetti: listaSoggetti,

          name: 'saveSoggetto'
        }

        // this.outputEmit.emit(dataOuptput)
        this.outputEmit.emit(dataOuptput)
        //this.convalidDataGrid()

        break;

    }
  }

}
